<template>
  <div class="cursor-pointer inline-flex items-center">
    <a href="/" class="mr-1" style="max-width: 250px">
      <img 
        :src="headerLogo" 
        style="max-height: 28px"
        draggable="false"
      />
    </a>
    <span
      @click="toggle()"
      v-if="!this.showOverlay && showToggler"
      class="w-9 h-9 inline-flex items-center mr-2 ml-1 flex-shrink-0"
    >
      <aw-icon
        icon="chevron-down"
        class="w-4 h-4 ml-1.5   flex-shrink-0"
      ></aw-icon>
    </span>
    <span
      @click="toggle()"
      v-if="this.showOverlay && showToggler"
      class="w-9 h-9 inline-flex items-center mr-2 ml-1 flex-shrink-0"
    >
      <aw-icon
        icon="chevron-up"
        class="w-4 h-4 ml-1.5  "
      ></aw-icon>
    </span>
  </div>

  <teleport v-if="showOverlay" to="#domains-overlay">
    <div
      class="CompaniesDropdown fixed rounded bg-bc-gray-bg text-sm left-0 right-0 shadow-md z-10 pb-16"
    >
      <div
        v-if="!bcDomainStore.loading"
        class="Squares gap-4 lg:gap-6 !px-4 py-4"
      >
        <a
          :href="domain.url"
          class="Square"
          v-for="domain in bcDomainStore.domains"
          :key="domain.id"
        >
          <div class="Square__Pic bg-white">
            <img class="rounded" :src="domain.preview" alt="" />
          </div>
          <div
            class="Square__Text leading-tight py-1 text-sm text-gray-500 text-center"
          >
            <div class="line-clamp">{{ domain.name }}</div>
          </div>
        </a>
      </div>
    </div>
  </teleport>
</template>

<script>
import { mapStores } from 'pinia'
import useBcDomainStore from '@/frontapp/store/bcDomain'

export default {
  props: {
    showToggler: {
      type: Boolean,
      default: true
    },
    headerLogo: String
  },
  data() {
    return {
      showOverlay: false
    }
  },
  computed: {
    ...mapStores(useBcDomainStore)
  },
  methods: {
    toggle() {
      if (!this.showToggler) {
        return
      }

      this.showOverlay = !this.showOverlay
      if (this.showOverlay && this.bcDomainStore.loading === true) {
        this.bcDomainStore.loadDomains()
      }

      this.$nextTick(() => {
        if (this.showOverlay) {
          document.documentElement.classList.add('lock')
          document.body.classList.add('lock', 'Show-CompaniesDropdown')
        } else {
          document.documentElement.classList.remove('lock')
          document.body.classList.remove('lock', 'Show-CompaniesDropdown')
        }
      })
    }
  },
}
</script>

<style lang="scss" scoped></style>
